define('commons/toggle-selector',['jquery'], function($) {

    var ToggleSelector = function(container, options) {

        // Default options overriding
        this.settings = $.extend({
            onItemSelected: function(data) {},
        }, options);

        this.container = $(container);

        var here = this;

        // add listeners
        this.container.find(".toggle-option").on("click", function(event){
            var $item = $(this);
            if(!$item.hasClass("selected")){
                here.settings.onItemSelected(event);
                // remove class for all options
                $(".toggle-option").removeClass("selected");
                $item.addClass("selected");
            }
        });
    };

    return ToggleSelector;
});
